import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button, Card, DataTable, EmptyState, Status, formatEuro } from '@elbklar/ui';
import { type TopDealItem } from '@/lib/api';

interface AnfragenListProps {
  deals: TopDealItem[];
}

export function AnfragenList({ deals }: AnfragenListProps) {
  const navigate = useNavigate();

  if (deals.length === 0) {
    return (
      <Card title="Anfragen im Fokus" description="Aktive Anfragen" icon={ArrowRight}>
        <EmptyState title="Keine offenen Anfragen" description="Aktive Anfragen erscheinen hier, sobald eine angelegt ist." />
      </Card>
    );
  }

  return (
    <Card
      title="Anfragen im Fokus"
      description={`${deals.length} aktive Anfragen`}
      icon={ArrowRight}
      flush
      actions={
        <Button size="sm" variant="ghost" onClick={() => navigate('/pipeline')}>
          Pipeline anzeigen
        </Button>
      }
    >
      <DataTable<TopDealItem>
        label="Aktive Anfragen"
        className="rounded-none border-0"
        rows={deals}
        onRowClick={() => navigate('/pipeline')}
        columns={[
          { key: 'name', header: 'Anfrage', strong: true, mobil: 'titel' },
          {
            key: 'status',
            header: 'Status',
            mobil: 'status',
            render: (deal) => <Status status={deal.status} variant="plain" />,
          },
          { key: 'value', header: 'Wert', align: 'end', mono: true, mobil: 'wert', render: (deal) => formatEuro(deal.value) },
        ]}
      />
    </Card>
  );
}
